export default __webpack_public_path__ + "static/media/pendulum.d06cb24d.svg";